import { useState } from "react";
import { Loader2, Lock, BadgeCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, formatErr, startReviewCheckout } from "@/lib/api";
import { BLUEPRINT_PRICE, BLUEPRINT_MONTHLY } from "@/lib/blueprint";
import { toast } from "sonner";

export function UnlockButtons({ bp, onUnlocked, dark = false }) {
  const [busy, setBusy] = useState("");
  const pay = (plan) => {
    setBusy(plan);
    api.post(`/blueprints/${bp.blueprint_id}/checkout`, { plan, origin_url: window.location.origin }).then((r) => { window.location.href = r.data.checkout_url; })
      .catch((e) => { toast.error(formatErr(e)); setBusy(""); });
  };
  const unlock = () => { setBusy("plan"); api.post(`/blueprints/${bp.blueprint_id}/unlock`).then((r) => { onUnlocked(r.data); toast.success("Unlocked — researching local codes now"); }).catch((e) => toast.error(formatErr(e))).finally(() => setBusy("")); };
  if (bp.can_unlock_with_plan) return <Button onClick={unlock} disabled={!!busy} className="bg-emerald-600 hover:bg-emerald-700" data-testid="bp-unlock-plan-button">{busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Lock className="h-4 w-4 mr-2" />}Unlock with my add-on</Button>;
  return (
    <div className="flex flex-wrap gap-2">
      <Button onClick={() => pay("single")} disabled={!!busy} className="bg-emerald-600 hover:bg-emerald-700" data-testid="bp-buy-single-button">{busy === "single" ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Lock className="h-4 w-4 mr-2" />}Unlock this blueprint — ${BLUEPRINT_PRICE}</Button>
      <Button variant="outline" onClick={() => pay("monthly")} disabled={!!busy} className={dark ? "bg-transparent text-white border-slate-500 hover:bg-white/10 hover:text-white" : ""} data-testid="bp-buy-monthly-button">{busy === "monthly" && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Unlimited — ${BLUEPRINT_MONTHLY}/mo</Button>
    </div>
  );
}

export function ReviewerButton({ bp, dark = false }) {
  const [busy, setBusy] = useState(false);
  const go = () => {
    if (!bp?.proposal_id) return toast.info("Unlock the blueprint and attach it to a proposal first, then send both to a certified reviewer.");
    setBusy(true);
    startReviewCheckout(bp.proposal_id).catch((e) => { toast.error(formatErr(e)); setBusy(false); });
  };
  return <Button variant="outline" onClick={go} disabled={busy} className={dark ? "bg-transparent text-white border-emerald-500/60 hover:bg-emerald-500/10 hover:text-white" : "border-emerald-600 text-emerald-700"} data-testid="bp-send-reviewer-button">{busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <BadgeCheck className="h-4 w-4 mr-2" />}Route to certified human reviewer</Button>;
}
